import React, { useState } from 'react';
import { PedidoModification } from '../../Types';
import './Table.scss';
import TableDateFormatter from '../../../../../../components/common/Table/TableDateFormatter';
import { formatCurrency } from '../../../../../../utils/functions';
import { HiOutlineEye } from 'react-icons/hi2';
import ModificationDetail from './components/ModificationDetail/ModificationDetail';

interface TableProps {
  data: PedidoModification[];
}

const Table: React.FC<TableProps> = ({ data }) => {
  const [showDetail, setShowDetail] = useState(false);
  const [selectedModification, setSelectedModification] = useState<PedidoModification | null>(null);

  const handleShowDetail = (modification: PedidoModification) => {
    setSelectedModification(modification);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedModification(null);
  };

  const NaCell = () => (
    <span className="mp-badge mp-badge-neutral">N/A</span>
  );

  if (data.length === 0) {
    return (
      <div className="mp-empty-state">
        <p>No se encontraron modificaciones</p>
      </div>
    );
  }

  return (
    <>
      <div className="mp-table-card">
        <div className="overflow-x-auto overflow-y-auto mp-scrollbar" style={{ maxHeight: '70vh' }}>
          <table className="mp-table">
            <thead className="mp-table-head">
              <tr>
                <th>Usuario</th>
                <th>Ejecutor</th>
                <th>Mesa</th>
                <th className="hidden lg:table-cell">Detalle</th>
                <th>Monto</th>
                <th>Fecha</th>
                <th>Detalles</th>
              </tr>
            </thead>
            <tbody className="mp-table-body">
              {data.map((mod) => (
                <tr key={mod.modification_id}>
                  <td>{mod.user_name || <NaCell />}</td>
                  <td>{mod.approver_user_name || <NaCell />}</td>
                  <td>
                    {mod.mesa_tag || mod.mesa_number || mod.mesa_id || <NaCell />}
                  </td>
                  <td className="hidden lg:table-cell">
                    {mod.modification_detail ? (
                      <span className="block max-w-[250px] truncate text-sm" style={{ color: 'var(--text-color)' }}>
                        {mod.modification_detail}
                      </span>
                    ) : (
                      <NaCell />
                    )}
                  </td>
                  <td>
                    {mod.modification_amount != null ? (
                      <div className={`amount-badge ${mod.isnegative ? 'negative' : 'positive'}`}>
                        <span className="amount-arrow">
                          {mod.isnegative ? '↓' : '↑'}
                        </span>
                        <span className="amount-value">
                          {formatCurrency(Math.abs(mod.modification_amount))}
                        </span>
                      </div>
                    ) : (
                      <NaCell />
                    )}
                  </td>
                  <td>
                    <TableDateFormatter
                      data={mod.timestamp}
                      isRealTime={false}
                      stopCounting={true}
                      isTimestamp={true}
                    />
                  </td>
                  <td>
                    {mod.modification_detail ? (
                      <div className="flex items-center justify-center gap-1.5">
                        <button
                          className="mp-btn-icon"
                          onClick={() => handleShowDetail(mod)}
                          title="Ver detalles"
                        >
                          <HiOutlineEye size={16} />
                        </button>
                      </div>
                    ) : (
                      <NaCell />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mp-table-footer">
          {data.length} modificaci{data.length === 1 ? 'ón' : 'ones'}
        </div>
      </div>

      <ModificationDetail
        modification={selectedModification}
        show={showDetail}
        onClose={handleCloseDetail}
      />
    </>
  );
};

export default Table;
